// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("./Inter-Thin.woff2", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_1___ = new URL("./Inter-Thin.woff", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_2___ = new URL("./Inter-ExtraLight.woff2", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_3___ = new URL("./Inter-ExtraLight.woff", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_4___ = new URL("./Inter-Light.woff2", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_5___ = new URL("./Inter-Light.woff", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_6___ = new URL("./Inter-Regular.woff2", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_7___ = new URL("./Inter-Regular.woff", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_8___ = new URL("./Inter-Medium.woff2", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_9___ = new URL("./Inter-Medium.woff", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_10___ = new URL("./Inter-SemiBold.woff2", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_11___ = new URL("./Inter-SemiBold.woff", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_12___ = new URL("./Inter-Bold.woff2", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_13___ = new URL("./Inter-Bold.woff", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_14___ = new URL("./Inter-ExtraBold.woff2", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_15___ = new URL("./Inter-ExtraBold.woff", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_16___ = new URL("./Inter-Black.woff2", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_17___ = new URL("./Inter-Black.woff", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
var ___CSS_LOADER_URL_REPLACEMENT_1___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_1___);
var ___CSS_LOADER_URL_REPLACEMENT_2___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_2___);
var ___CSS_LOADER_URL_REPLACEMENT_3___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_3___);
var ___CSS_LOADER_URL_REPLACEMENT_4___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_4___);
var ___CSS_LOADER_URL_REPLACEMENT_5___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_5___);
var ___CSS_LOADER_URL_REPLACEMENT_6___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_6___);
var ___CSS_LOADER_URL_REPLACEMENT_7___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_7___);
var ___CSS_LOADER_URL_REPLACEMENT_8___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_8___);
var ___CSS_LOADER_URL_REPLACEMENT_9___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_9___);
var ___CSS_LOADER_URL_REPLACEMENT_10___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_10___);
var ___CSS_LOADER_URL_REPLACEMENT_11___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_11___);
var ___CSS_LOADER_URL_REPLACEMENT_12___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_12___);
var ___CSS_LOADER_URL_REPLACEMENT_13___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_13___);
var ___CSS_LOADER_URL_REPLACEMENT_14___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_14___);
var ___CSS_LOADER_URL_REPLACEMENT_15___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_15___);
var ___CSS_LOADER_URL_REPLACEMENT_16___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_16___);
var ___CSS_LOADER_URL_REPLACEMENT_17___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_17___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Thin 100 */

@font-face {
    font-family: Inter;
    font-weight: 100;
    font-style: normal;
    src:
        url(${___CSS_LOADER_URL_REPLACEMENT_0___}) format('woff2'),
        url(${___CSS_LOADER_URL_REPLACEMENT_1___}) format('woff');
}

/* ExtraLight 200 */

@font-face {
    font-family: Inter;
    font-weight: 200;
    font-style: normal;
    src:
        url(${___CSS_LOADER_URL_REPLACEMENT_2___}) format('woff2'),
        url(${___CSS_LOADER_URL_REPLACEMENT_3___}) format('woff');
}

/* Light 300 */

@font-face {
    font-family: Inter;
    font-weight: 300;
    font-style: normal;
    src:
        url(${___CSS_LOADER_URL_REPLACEMENT_4___}) format('woff2'),
        url(${___CSS_LOADER_URL_REPLACEMENT_5___}) format('woff');
}

/* Regular 400 */

@font-face {
    font-family: Inter;
    font-weight: normal;
    font-style: normal;
    src:
        url(${___CSS_LOADER_URL_REPLACEMENT_6___}) format('woff2'),
        url(${___CSS_LOADER_URL_REPLACEMENT_7___}) format('woff');
}

@font-face {
    font-family: Inter;
    font-weight: 400;
    font-style: normal;
    src:
        url(${___CSS_LOADER_URL_REPLACEMENT_6___}) format('woff2'),
        url(${___CSS_LOADER_URL_REPLACEMENT_7___}) format('woff');
}

/* Medium 500 */

@font-face {
    font-family: Inter;
    font-weight: 500;
    font-style: normal;
    src:
        url(${___CSS_LOADER_URL_REPLACEMENT_8___}) format('woff2'),
        url(${___CSS_LOADER_URL_REPLACEMENT_9___}) format('woff');
}

/* SemiBold 600 */

@font-face {
    font-family: Inter;
    font-weight: 600;
    font-style: normal;
    src:
        url(${___CSS_LOADER_URL_REPLACEMENT_10___}) format('woff2'),
        url(${___CSS_LOADER_URL_REPLACEMENT_11___}) format('woff');
}

/* Bold 700 */

@font-face {
    font-family: Inter;
    font-weight: 700;
    font-style: normal;
    src:
        url(${___CSS_LOADER_URL_REPLACEMENT_12___}) format('woff2'),
        url(${___CSS_LOADER_URL_REPLACEMENT_13___}) format('woff');
}

@font-face {
    font-family: Inter;
    font-weight: bold;
    font-style: normal;
    src:
        url(${___CSS_LOADER_URL_REPLACEMENT_12___}) format('woff2'),
        url(${___CSS_LOADER_URL_REPLACEMENT_13___}) format('woff');
}

/* ExtraBold 800 */

@font-face {
    font-family: Inter;
    font-weight: 800;
    font-style: normal;
    src:
        url(${___CSS_LOADER_URL_REPLACEMENT_14___}) format('woff2'),
        url(${___CSS_LOADER_URL_REPLACEMENT_15___}) format('woff');
}

/* Black 900 */

@font-face {
    font-family: Inter;
    font-weight: 900;
    font-style: normal;
    src:
        url(${___CSS_LOADER_URL_REPLACEMENT_16___}) format('woff2'),
        url(${___CSS_LOADER_URL_REPLACEMENT_17___}) format('woff');
}
`, "",{"version":3,"sources":["webpack://./public/fonts/inter/inter.css"],"names":[],"mappings":"AAAA,aAAa;;AAEb;IACI,kBAAkB;IAClB,gBAAgB;IAChB,kBAAkB;IAClB;;8DAE2C;AAC/C;;AAEA,mBAAmB;;AAEnB;IACI,kBAAkB;IAClB,gBAAgB;IAChB,kBAAkB;IAClB;;8DAEiD;AACrD;;AAEA,cAAc;;AAEd;IACI,kBAAkB;IAClB,gBAAgB;IAChB,kBAAkB;IAClB;;8DAE4C;AAChD;;AAEA,gBAAgB;;AAEhB;IACI,kBAAkB;IAClB,mBAAmB;IACnB,kBAAkB;IAClB;;8DAE8C;AAClD;;AAEA;IACI,kBAAkB;IAClB,gBAAgB;IAChB,kBAAkB;IAClB;;8DAE8C;AAClD;;AAEA,eAAe;;AAEf;IACI,kBAAkB;IAClB,gBAAgB;IAChB,kBAAkB;IAClB;;8DAE6C;AACjD;;AAEA,iBAAiB;;AAEjB;IACI,kBAAkB;IAClB,gBAAgB;IAChB,kBAAkB;IAClB;;+DAE+C;AACnD;;AAEA,aAAa;;AAEb;IACI,kBAAkB;IAClB,gBAAgB;IAChB,kBAAkB;IAClB;;+DAE2C;AAC/C;;AAEA;IACI,kBAAkB;IAClB,iBAAiB;IACjB,kBAAkB;IAClB;;+DAE2C;AAC/C;;AAEA,kBAAkB;;AAElB;IACI,kBAAkB;IAClB,gBAAgB;IAChB,kBAAkB;IAClB;;+DAEgD;AACpD;;AAEA,cAAc;;AAEd;IACI,kBAAkB;IAClB,gBAAgB;IAChB,kBAAkB;IAClB;;+DAE4C;AAChD","sourcesContent":["/* Thin 100 */\n\n@font-face {\n    font-family: Inter;\n    font-weight: 100;\n    font-style: normal;\n    src:\n        url('./Inter-Thin.woff2') format('woff2'),\n        url('./Inter-Thin.woff') format('woff');\n}\n\n/* ExtraLight 200 */\n\n@font-face {\n    font-family: Inter;\n    font-weight: 200;\n    font-style: normal;\n    src:\n        url('./Inter-ExtraLight.woff2') format('woff2'),\n        url('./Inter-ExtraLight.woff') format('woff');\n}\n\n/* Light 300 */\n\n@font-face {\n    font-family: Inter;\n    font-weight: 300;\n    font-style: normal;\n    src:\n        url('./Inter-Light.woff2') format('woff2'),\n        url('./Inter-Light.woff') format('woff');\n}\n\n/* Regular 400 */\n\n@font-face {\n    font-family: Inter;\n    font-weight: normal;\n    font-style: normal;\n    src:\n        url('./Inter-Regular.woff2') format('woff2'),\n        url('./Inter-Regular.woff') format('woff');\n}\n\n@font-face {\n    font-family: Inter;\n    font-weight: 400;\n    font-style: normal;\n    src:\n        url('./Inter-Regular.woff2') format('woff2'),\n        url('./Inter-Regular.woff') format('woff');\n}\n\n/* Medium 500 */\n\n@font-face {\n    font-family: Inter;\n    font-weight: 500;\n    font-style: normal;\n    src:\n        url('./Inter-Medium.woff2') format('woff2'),\n        url('./Inter-Medium.woff') format('woff');\n}\n\n/* SemiBold 600 */\n\n@font-face {\n    font-family: Inter;\n    font-weight: 600;\n    font-style: normal;\n    src:\n        url('./Inter-SemiBold.woff2') format('woff2'),\n        url('./Inter-SemiBold.woff') format('woff');\n}\n\n/* Bold 700 */\n\n@font-face {\n    font-family: Inter;\n    font-weight: 700;\n    font-style: normal;\n    src:\n        url('./Inter-Bold.woff2') format('woff2'),\n        url('./Inter-Bold.woff') format('woff');\n}\n\n@font-face {\n    font-family: Inter;\n    font-weight: bold;\n    font-style: normal;\n    src:\n        url('./Inter-Bold.woff2') format('woff2'),\n        url('./Inter-Bold.woff') format('woff');\n}\n\n/* ExtraBold 800 */\n\n@font-face {\n    font-family: Inter;\n    font-weight: 800;\n    font-style: normal;\n    src:\n        url('./Inter-ExtraBold.woff2') format('woff2'),\n        url('./Inter-ExtraBold.woff') format('woff');\n}\n\n/* Black 900 */\n\n@font-face {\n    font-family: Inter;\n    font-weight: 900;\n    font-style: normal;\n    src:\n        url('./Inter-Black.woff2') format('woff2'),\n        url('./Inter-Black.woff') format('woff');\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
